<template>
    <div class="uav-container">
        <!-- PC端显示 -->
        <div class="card" v-if="pageWidth > 1000">
            <div class="situation">
                <!-- 产品简介部分 -->
                <div class="radio">
                    <div class="text animate__animated animate__fadeInLeft">
                        <h2 class="title">06 <span>抗干扰无人机系统</span></h2>
                        <p class="introduction">
                            抗干扰无人机是一款专为应对复杂环境设计的智能无人机平台。该系统具备强大的抗干扰能力，能够在复杂地形、非视距环境、宽频带电磁干扰以及GNSS导航信号丢失的情况下，实现无人机的自主起降、悬停及安全作业。该平台结合光电吊舱、光学相机等先进设备，实现远程监控、实时图像传输等多种功能，极大提高了复杂环境下的作业效率和安全性。
                        </p>
                    </div>
                    <div class="image animate__animated animate__fadeInRight">
                        <img src="@/assets/solution/uav/uav.png" alt="抗干扰无人机系统">
                        <p>抗干扰无人机系统</p>
                    </div>
                </div>

                <!-- 产品特色和系统参数容器 -->
                <div class="features-container">
                    <!-- 产品特色部分 -->
                    <div class="text technicalPoints">
                        <h3 class="title"><span>产品特色</span></h3>
                        <div v-for="(point, index) in productFeatures" :key="index">
                            <h4>{{ point.title }}</h4>
                            <p>{{ point.description }}</p>
                        </div>
                    </div>

                    <!-- 产品组成部分 -->
                    <div class="function-section">
                        <div class="text productFunctions">
                            <h3 class="title"><span>产品组成</span></h3>
                            <div v-for="(func, index) in productFunctions" :key="index">
                                <h4>{{ func.title }}</h4>
                                <p>{{ func.description }}</p>
                            </div>
                        </div>
                        <div class="function-image animate__animated animate__fadeInRight">
                            <div class="image-wrapper">
                                <img src="@/assets/solution/uav/uav2.png" alt="产品组成示意图">
                                <p style="font-size: 18px;font-weight: bold;">抗干扰无人机系统界面</p>
                            </div>
                        </div>
                    </div>

                    <!-- 系统参数部分 -->
                    <div class="params-section">
                        <div class="text systemParams">
                            <h3 class="title"><span>系统参数</span></h3>
                            <table class="params-table">
                                <tr>
                                    <th>系统组件</th>
                                    <th>功能参数</th>
                                </tr>
                                <tr>
                                    <td>光电吊舱／云台</td>
                                    <td>
                                        <ul>
                                            <li>可受控调整方向</li>
                                            <li>★支持2种以上相机（双光相机吊舱和高速相机吊舱可切换）</li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td>光学相机</td>
                                    <td>
                                        <ul>
                                            <li>★支持光学变焦功能（可见光变焦）</li>
                                            <li>支持观测视频／图像数据本地存储和关键帧远程实时传输，关键帧图像快速回传及慢动作回放</li>
                                            <li>图像支持 bmp/jpg/png 等格式</li>
                                            <li>视频支持avi/MP4 等格式</li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td>机载电脑</td>
                                    <td>
                                        <ul>
                                            <li>★支持高速图像处理</li>
                                        </ul>
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div class="params-image animate__animated animate__fadeInRight">
                            <div class="image-wrapper">
                                <img src="@/assets/solution/uav/uav3.png" alt="系统参数示意图">
                                <p style="font-size: 18px;font-weight: bold;">抗干扰无人机系统参数</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

<!--            &lt;!&ndash; 产品形态部分 &ndash;&gt;-->
<!--            <div class="text productForm" ref="text">-->
<!--                <h3 class="title"><span>产品形态</span></h3>-->
<!--                <div class="device">-->
<!--                    <div v-for="(form, index) in productForms" :key="index">-->
<!--                        <img :src="form.image" :alt="form.title">-->
<!--                        <h4>{{ form.title }}</h4>-->
<!--                        <p>{{ form.description }}</p>-->
<!--                    </div>-->
<!--                </div>-->

<!--                &lt;!&ndash; 应用场景部分 &ndash;&gt;-->
<!--                <div>-->
<!--                    <h3 class="title"><span>应用场景</span></h3>-->
<!--                    <div class="scenario">-->
<!--                        <div ref="text">-->
<!--                            <div v-for="(scene, index) in applicationScenes" :key="index">-->
<!--                                <h4>{{ scene.title }}</h4>-->
<!--                                <p>{{ scene.description }}</p>-->
<!--                            </div>-->
<!--                        </div>-->

<!--                        <div class="image_box" ref="img">-->
<!--                            <img v-for="(image, index) in sceneImages"-->
<!--                                 :key="index"-->
<!--                                 :src="image"-->
<!--                                 :alt="`场景图片${index + 1}`">-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
        </div>

        <!-- 移动端显示 -->
        <div class="card" v-else>
            <div class="situation">
                <div class="text animate__animated animate__fadeInLeft">
                    <h2 class="title">06 <span>抗干扰无人机</span></h2>
                    <p class="introduction">
                        抗干扰无人机是一款专为应对复杂环境设计的智能无人机平台。该系统具备强大的抗干扰能力，能够在复杂地形、非视距环境、宽频带电磁干扰以及GNSS导航信号丢失的情况下，实现无人机的自主起降、悬停及安全作业。该平台结合光电吊舱、光学相机等先进设备，实现远程监控、实时图像传输等多种功能，极大提高了复杂环境下的作业效率和安全性。
                    </p>
                    <div class="image animate__animated animate__fadeInRight">
                        <img src="@/assets/solution/uav/uav.png" alt="抗干扰无人机">
                        <p>抗干扰无人机</p>
                    </div>

                    <!-- 产品特色部分 -->
                    <div class="technicalPoints">
                        <h3 class="title"><span>技术要点</span></h3>
                        <div v-for="(point, index) in productFeatures" :key="index">
                            <h4>{{ point.title }}</h4>
                            <p>{{ point.description }}</p>
                        </div>
                    </div>

                    <!-- 添加系统参数部分 -->
                    <div class="systemParams">
                        <h3 class="title"><span>系统参数</span></h3>
                        <table class="params-table">
                            <tr>
                                <th>系统组件</th>
                                <th>功能参数</th>
                            </tr>
                            <tr>
                                <td>光电吊舱／云台</td>
                                <td>
                                    <ul>
                                        <li>可受控调整方向</li>
                                        <li>支持2种以上相机（双光相机吊舱和高速相机吊舱可切换）</li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td>光学相机</td>
                                <td>
                                    <ul>
                                        <li>★支持光学变焦功能（可见光变焦）</li>
                                        <li>支持观测视频／图像数据本地存储和关键帧远程实时传输，关键帧图像快速回传及慢动作回放</li>
                                        <li>图像支持 bmp/jpg/png 等格式</li>
                                        <li>视频支持avi/MP4 等格式</li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td>机载电脑</td>
                                <td>
                                    <ul>
                                        <li>★支持高速图像处理</li>
                                    </ul>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>

<!--            &lt;!&ndash; 产品形态和应用场景 &ndash;&gt;-->
<!--            <div class="compose">-->
<!--                <div class="text" ref="text">-->
<!--                    &lt;!&ndash; 产品形态部分 &ndash;&gt;-->
<!--                    <h3 class="title"><span>产品形态</span></h3>-->
<!--                    <div v-for="(form, index) in productForms" :key="index">-->
<!--                        <h4>{{ form.title }}</h4>-->
<!--                        <p>{{ form.description }}</p>-->
<!--                        <div class="img">-->
<!--                            <img :src="form.image" :alt="form.title">-->
<!--                            <p>{{ form.title }}</p>-->
<!--                        </div>-->
<!--                    </div>-->

<!--                    &lt;!&ndash; 应用场景部分 &ndash;&gt;-->
<!--                    <h3 class="title"><span>应用场景</span></h3>-->
<!--                    <div v-for="(scene, index) in applicationScenes" :key="index">-->
<!--                        <h4>{{ scene.title }}</h4>-->
<!--                        <p>{{ scene.description }}</p>-->
<!--                        <div class="img" v-if="sceneImages[index]">-->
<!--                            <img :src="sceneImages[index]" :alt="scene.title">-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
        </div>
    </div>
</template>

<script>
export default {
    name: 'UavComponent',

    data() {
        return {
            pageWidth: window.innerWidth,
            // 产品特色数据
            productFeatures: [
                {
                    title: '稳定飞行',
                    description: '具备在GNSS导航信号受干扰或丢失的情况下自主起降与稳定飞行的能力。'
                },
                {
                    title: '悬停观测',
                    description: '具备悬停观测能力。'
                },
                {
                    title: '远程控制',
                    description: '具备远程地面站控制（加光纤控制）、多通道遥控器操作功能。'
                }
            ],
            // 产品形态数据
            productForms: [
                {
                    title: '无人机频谱监测',
                    description: '利用无人机搭载频谱监测设备，可以对较大范围的区域进行频谱监测，实现快速、高效的监测任务。',
                    image: require('@/assets/solution/cehui/xingtai1.png')
                },
                {
                    title: '固定台站式频谱监测',
                    description: '在固定位置设置专门的频谱监测台站，可以持续监测特定区域的频谱使用情况，提供长期的监测数据支持。',
                    image: require('@/assets/solution/cehui/xingtai2.png')
                }
            ],
            // 应用场景数据
            applicationScenes: [
                {
                    title: '电信频谱管理',
                    description: '无线电监测可以用于监测和管理无线电频谱的使用情况，确保频谱资源的合理分配和有效利用。通过监测无线电信号强度、频率占用情况等数据，可以帮助电信管理机构进行频段规划和频谱分配，避免频谱干扰和冲突。'
                },
                {
                    title: '无线电干扰监测',
                    description: '无线电监测可以用于检测和识别无线电信号的干扰源。当出现无线电干扰时，通过监测信号的频率、强度、调制方式等特征，可以确定干扰源的位置和类型，及时采取干扰抑制措施，保障正常通信服务的稳定性和可靠性。'
                },
                {
                    title: '电磁环境监测',
                    description: '无线电监测可以用于对电磁环境进行监测和评估。通过对周围环境中的无线电信号进行监测，可以得到电磁辐射强度、频率分布等数据，评估电磁辐射对人体健康和环境的影响，为相关政策制定和环境保护提供科学依据。'
                },
                {
                    title: '无线电通信安全',
                    description: '无线电监测可以用于保障无线电通信的安全性。通过监测无线电信号的频谱活动情况，可以发现非法窃听、窃取信息等安全威胁，及时采取对策，防止信息泄露和通信被攻击。'
                },
                {
                    title: '边境管控与执法',
                    description: '无线电监测可以用于边境管控和执法行动。通过监测边境地区的无线电信号，可以发现非法越境、走私、通信黑点等违法活动，协助执法部门加强边境安全管理和打击犯罪行为。'
                }
            ],
            // 应用场景图片
            sceneImages: [
                require('@/assets/solution/cehui/radio1.png'),
                require('@/assets/solution/cehui/radio2.png'),
                require('@/assets/solution/cehui/radio3.png'),
                require('@/assets/solution/cehui/radio4.png')
            ],
            // 产品组成数据
            productFunctions: [
                {
                    title: '具身导航模块',
                    description: '嵌入具身视觉导航算法，设计认知逃逸与语义认知模块,根据历史信息识别出局部最优,基于专家知识快速制定逃离策略，并通过映射到语义空间提高策略泛化性。'
                },
                {
                    title: '具身检测模块',
                    description: '嵌入具身检测算法，将多尺度、多视角下的序贯信息进行融合与利用，以消除伪目标干扰，保证对真实目标的实时检测。'
                },
                {
                    title: '具身跟踪模块',
                    description: '嵌入具身跟踪算法，在具身检测算法的基础上，持续融合序贯信息，输出具身动作引导无人机产生运动轨迹，保证在复杂场景下对真实目标的持续跟踪。'
                }
            ]
        }
    },

    mounted() {
        this.initializeEventListeners();
        this.setupIntersectionObservers();
    },

    beforeDestroy() {
        this.removeEventListeners();
    },

    methods: {
        // 初始化事件监听器
        initializeEventListeners() {
            window.addEventListener('resize', this.handleResize);
        },

        // 移除事件监听器
        removeEventListeners() {
            window.removeEventListener('resize', this.handleResize);
        },

        // 处理窗口大小变化
        handleResize() {
            this.pageWidth = window.innerWidth;
        },

        // 设置交叉观察器
        setupIntersectionObservers() {
            this.$nextTick(() => {
                this.setupElementObserver(this.$refs.text, 'animate__fadeInLeft');
                this.setupElementObserver(this.$refs.img, 'animate__fadeInRight');
            });
        },

        // 创建元素观察器
        setupElementObserver(element, animationClass) {
            if (!element) return;

            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        element.classList.add('animate__animated', animationClass);
                        observer.disconnect();
                    }
                });
            });

            observer.observe(element);
        }
    }
}
</script>

<style scoped lang="less">
@import '../../../styles/spectrum/radioMonitoring';

// 添加新的样式
.uav-container {
    .introduction {
        text-indent: 2em;
    }

    .mobile-view {
        // 移动端特定样式
    }
}

.mobile-view {
    .compose {
        .text {
            .img {
                margin: 15px 0;
                text-align: center;

                img {
                    max-width: 100%;
                    height: auto;
                }

                p {
                    margin-top: 10px;
                    text-align: center;
                }
            }
        }
    }

    .technicalPoints {
        margin: 20px 0;
    }

    .introduction {
        text-indent: 2em;
        margin: 15px 0;
    }
}

.features-container {
    display: flex;
    flex-direction: column;
    gap: 30px;  // 控制产品特色和系统参数之间的间距
    margin-top: 30px;

    .function-section {
        display: flex;
        gap: 40px;
        align-items: flex-start;
        margin: 0;

        .productFunctions {
            flex: 1;
            margin: 0;
            
            h4 {
                color: #333;
                margin: 20px 0 10px;
                font-size: 16px;
            }
            
            p {
                color: #666;
                line-height: 1.6;
                margin-bottom: 15px;
                text-align: justify;
            }
        }

        .function-image {
            width: 45%;
            margin-top: 80px;  // 增加上边距，让图片往下移
            
            .image-wrapper {
                text-align: center;

                img {
                    width: 100%;
                    height: auto;
                    border-radius: 4px;
                    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
                    margin-bottom: 10px;
                }

                p {
                    color: #666;
                    font-size: 14px;
                    margin: 0;
                    text-align: center;
                }
            }
        }
    }

    .params-section {
        display: flex;
        gap: 40px;
        align-items: flex-start;
        margin: 0;

        .systemParams {
            flex: 1;
            margin: 0;

            .params-table {
                width: 100%;
                border-collapse: collapse;
                margin-top: 20px;
                table-layout: fixed;

                th, td {
                    border: 1px solid #ddd;
                    padding: 12px 15px;
                    text-align: left;
                }

                th:first-child,
                td:first-child {
                    width: 25%;
                }

                th:last-child,
                td:last-child {
                    width: 75%;
                }

                th {
                    background-color: #f5f5f5;
                    font-weight: bold;
                }

                ul {
                    list-style: none;
                    margin: 0;
                    padding: 0;

                    li {
                        position: relative;
                        padding-left: 15px;
                        margin: 5px 0;

                        &:before {
                            content: "•";
                            position: absolute;
                            left: 0;
                            color: #666;
                        }
                    }
                }
            }
        }

        .params-image {
            width: 45%;
            margin-top: 80px;  // 同样增加系统参数图片的上边距
            
            .image-wrapper {
                text-align: center;

                img {
                    width: 100%;
                    height: auto;
                    border-radius: 4px;
                    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
                    margin-bottom: 10px;
                }

                p {
                    color: #666;
                    margin: 0;
                    text-align: center;
                }
            }
        }
    }
}

// 确保在移动端时恢复原有布局
@media screen and (max-width: 1000px) {
    .features-container {
        display: flex;
        flex-direction: column;
        gap: 20px;
        margin-top: 20px;

        // 产品特色部分移动端样式
        .technicalPoints {
            h3 {
                font-size: 18px;
            }
            
            h4 {
                font-size: 15px;
                margin: 12px 0 8px;
            }
            
            p {
                font-size: 14px;
                line-height: 1.5;
                margin-bottom: 12px;
            }
        }

        // 产品组成部分移动端样式
        .function-section {
            flex-direction: column;
            gap: 15px;
            margin-top: 20px;

            .productFunctions {
                margin: 0;
                
                h3 {
                    font-size: 18px;
                }
                
                h4 {
                    font-size: 15px;
                    margin: 12px 0 8px;
                }
                
                p {
                    font-size: 14px;
                    line-height: 1.5;
                    margin-bottom: 12px;
                }
            }

            .function-image {
                width: 100%;
                margin: 10px 0;

                .image-wrapper {
                    img {
                        margin-bottom: 8px;
                    }
                    p {
                        font-size: 15px;
                        font-weight: 500;
                    }
                }
            }
        }

        // 系统参数部分移动端样式
        .params-section {
            flex-direction: column;
            gap: 15px;
            margin-top: 20px;

            .systemParams {
                width: 100%;
                
                h3 {
                    font-size: 18px;
                }

                .params-table {
                    margin-top: 15px;
                    font-size: 14px;

                    th, td {
                        padding: 8px 10px;
                    }

                    ul li {
                        margin: 3px 0;
                        line-height: 1.5;
                    }
                }
            }

            .params-image {
                width: 100%;
                margin: 10px 0;

                .image-wrapper {
                    img {
                        margin-bottom: 8px;
                    }
                    p {
                        font-size: 15px;
                        font-weight: 500;
                    }
                }
            }
        }
    }

    // 产品简介部分移动端样式
    .situation {
        .radio {
            .text {
                h2 {
                    font-size: 20px;
                }
                
                .introduction {
                    font-size: 14px;
                    line-height: 1.6;
                    margin: 15px 0;
                }
            }
            
            .image {
                margin: 15px 0;
                
                p {
                    font-size: 15px;
                    margin-top: 8px;
                }
            }
        }
    }
}
</style>
